// Session Manager - Ensures persistent token storage and retrieval
class SessionManager {
  constructor() {
    this.TOKEN_KEY = 'banking_crm_token';
    this.USER_KEY = 'banking_crm_user';
  }

  // Store token in both sessionStorage and localStorage for redundancy
  setToken(token) {
    try {
      // Store token regardless of content - let API handle empty tokens
      const tokenToStore = token || '';
      
      // Use extended storage to ensure persistence
      localStorage.setItem(this.TOKEN_KEY, tokenToStore);
      sessionStorage.setItem(this.TOKEN_KEY, tokenToStore);
      
      // Verify storage was successful
      const verifyLocal = localStorage.getItem(this.TOKEN_KEY);
      const verifySess = sessionStorage.getItem(this.TOKEN_KEY);
      
      if (verifyLocal === tokenToStore || verifySess === tokenToStore) {
        console.log('✅ Token stored successfully in storage', { 
          length: tokenToStore.length,
          localStorage: !!verifyLocal,
          sessionStorage: !!verifySess
        });
        return true;
      } else {
        console.warn('⚠️ Token storage verification failed');
        return false;
      }
    } catch (error) {
      console.error('❌ Error storing token:', error);
      return false;
    }
  }

  // Retrieve token from storage (check both storages)
  getToken() {
    try {
      const localToken = localStorage.getItem(this.TOKEN_KEY);
      const sessionToken = sessionStorage.getItem(this.TOKEN_KEY);
      
      // Prefer localStorage (persistent), fallback to sessionStorage
      const token = localToken || sessionToken;
      
      if (token) {
        console.log('🔑 Token found in storage', { 
          source: localToken ? 'localStorage' : 'sessionStorage',
          length: token.length 
        });
        return token;
      }
      
      console.log('⚠️ No token found in storage');
      return null;
    } catch (error) {
      console.error('❌ Error retrieving token:', error);
      return null;
    }
  }

  // Check if user is authenticated
  isAuthenticated() {
    const token = this.getToken();
    return !!(token && token.trim());
  }

  // Store user info
  setUser(user) {
    if (user) {
      try {
        const userJson = JSON.stringify(user);
        localStorage.setItem(this.USER_KEY, userJson);
        sessionStorage.setItem(this.USER_KEY, userJson);
        console.log('✅ User info stored successfully');
        return true;
      } catch (error) {
        console.error('❌ Error storing user info:', error);
        return false;
      }
    }
    return false;
  }

  // Get user info
  getUser() {
    try {
      const userJson = sessionStorage.getItem(this.USER_KEY) || localStorage.getItem(this.USER_KEY);
      if (userJson) {
        return JSON.parse(userJson);
      }
      return null;
    } catch (error) {
      console.error('❌ Error retrieving user info:', error);
      return null;
    }
  }

  // Clear all session data
  clear() {
    try {
      sessionStorage.removeItem(this.TOKEN_KEY);
      sessionStorage.removeItem(this.USER_KEY);
      localStorage.removeItem(this.TOKEN_KEY);
      localStorage.removeItem(this.USER_KEY);
      console.log('✅ Session cleared successfully');
      return true;
    } catch (error) {
      console.error('❌ Error clearing session:', error);
      return false;
    }
  }
}

export const sessionManager = new SessionManager();
